import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataService } from '../data.service';
import { FormControl, NgForm, FormGroupDirective, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Preinscripcio } from '../lib/model/preinscripcio';
import { Localitat } from '../lib/model/localitat';
import { Pais } from '../lib/model/pais';
import { Utilitats } from '../lib/utilitats';
import { BLComConegut } from '../lib/bl/blcomconegut';
import { ComConegut} from '../lib/model/comconegut';
import { ErrorStateMatcher, MatSnackBar, MatStepper } from '@angular/material';
import { BLEnum } from '../lib/bl/blenum';
import { Enum } from '../lib/model/enum';
import { Universitat } from '../lib/model/universitat';
import { BLUniversitat } from '../lib/bl/bluniversitat';
import { BLPreinscripcio } from '../lib/bl/blpreinscripcio';

@Component({
  selector: 'app-altres',
  templateUrl: './altres.component.html',
  styleUrls: ['./altres.component.css'],
  providers: [BLComConegut, BLEnum, BLUniversitat, BLPreinscripcio]
})
export class AltresComponent implements OnInit {

  @ViewChild('formulari') formulari: NgForm;
  @Input() stepper: MatStepper;

  preinscripcio: Preinscripcio;
  comConegutList: ComConegut[];
  universitatsDobleTitulacioList: ComConegut[];
  presencialitats: Enum[];
  stepPerformed = false;

  constructor(public dataService: DataService,
              public utilitats: Utilitats,
              public blComConegut: BLComConegut,
              public blEnum: BLEnum,
              public blUniversitatsDobleTitulacio: BLUniversitat,
              public blPreinscripcio: BLPreinscripcio,
              public snackBar: MatSnackBar) {

        this.preinscripcio = this.dataService.preinscripcio;

  }

  async ngOnInit() {
    await this.loadComConegut();
    await this.loadPresencialitats();
    await this.loadUniversitatDobleTitulacio();
  }

  async loadPresencialitats() {
    this.presencialitats = await this.blEnum.list(
      'Udg.GausNET.Model.PreInscripcions.Presencialitat',
      this.dataService.current_language);
  }

  coneixementMasterChange(newValue) {
    if (newValue != null && newValue.value) {
      if ((this.preinscripcio.coneixementMaster === null) ||
          (this.preinscripcio.coneixementMaster.value !== newValue.value)) {
        this.preinscripcio.coneixementMaster = newValue;
      }
    } else {
      this.preinscripcio.coneixementMaster = null;
    }
  }

  compareConeixementMaster(c1: ComConegut, c2: ComConegut): boolean {
    return c1 && c2 ? c1.value === c2.value : c1 === c2;
  }

  async loadComConegut() {
    this.comConegutList = await this.blComConegut.list(this.dataService.current_language);
  }

  universitatDobleTitulacioChange(newValue) {
    if (newValue != null && newValue.value) {
      if ((this.preinscripcio.universitatDobleTitulacio === null) ||
          (this.preinscripcio.universitatDobleTitulacio.value !== newValue.value)) {
        this.preinscripcio.universitatDobleTitulacio = newValue;
      }
    } else {
      this.preinscripcio.universitatDobleTitulacio = null;
    }
  }

  compareuniversitatDobleTitulacio(c1: Universitat, c2: Universitat): boolean {
    return c1 && c2 ? c1.value === c2.value : c1 === c2;
  }

  async loadUniversitatDobleTitulacio() {
    this.universitatsDobleTitulacioList = await this.blUniversitatsDobleTitulacio.listDobleTitulacio(this.preinscripcio.oferta);
  }

  public isValid(): boolean {
    try {
      if (this.formulari == null) {
        return false;
      }
      if (this.formulari.form == null) {
        return false;
      }
      if (this.formulari.form.invalid) {
        return false;
      }
    } catch (ex) {
      console.log('Error a isValid()');
      console.log(ex.Message);
    }
    return true;
  }

  public async continua() {
    try {
      this.stepper.next();
      if (!this.stepPerformed) {
        this.dataService.maxStep++;
        this.stepPerformed = true;
      }
      if (!this.preinscripcio.isnew) {
        this.preinscripcio = await this.blPreinscripcio.save(this.preinscripcio);
        this.dataService.preinscripcio = this.preinscripcio;
      }
    } catch (ex) {
        console.log(ex.Message);
        this.snackBar.open(ex.Message, null, {
            duration: 10000,
          });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/altres/altres.component.ts